import React, { Fragment } from 'react';
import Translate from 'react-translate-component';

import EducationStages from 'components/sidebars/education/EducationStages';
import { DateTimeField } from 'components/common/fields/DateTimeFields';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import ActionDescriptionField from 'components/cards/education/action/ActionDescriptionField';

const ScenarioInfo = ({ info: { approveState, responsible, person, sender, send, scen = {}, stages, actionDescription } }) => scen.id ? (
    <Fragment>
        <div className="panel-view scenario-info">
            <DefinitionField translate="education.scenario.responsible" text={responsible.name} />
            <DefinitionField translate="education.scenario.person" text={person.name} />
            <DefinitionField translate="education.scenario.sender" text={sender.name} />
            <DefinitionField translate="education.scenario.send" show={send.date !== '0' && send.time !== '0'}>
                <DateTimeField date={send.date} time={send.time} />
            </DefinitionField>
            <DefinitionField translate="education.common.substate" show={!!approveState}>
                <Translate content={`education.common.approveState.${approveState}`} />
            </DefinitionField>
        </div>
        <ActionDescriptionField descriptions={[actionDescription]} />
        <EducationStages stages={stages} />
    </Fragment>
) : null;

export default ScenarioInfo;
